import { getContext, setContext } from 'svelte';
import type { RoomSession } from './room-session';

const KEY = Symbol('spellie.session');

/** The root component provides one session; screens read it instead of receiving it as a prop. */
export function provideSession(session: RoomSession): RoomSession {
  return setContext(KEY, session);
}

export function getSession(): RoomSession {
  const session = getContext<RoomSession | undefined>(KEY);
  if (!session) throw new Error('Room session context is missing; App must provide it');
  return session;
}
